import React, { useState } from 'react';
import classes from './outOfStock.module.scss';
import cn from "classnames";
import DateTimePicker from '../../Common/DateTimePicker/DateTimePicker';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const StockStatusConfirmationPopup = ({ stocked, setPopup, onProceed, selectedSearchItems, selectedTab }) => {
  const [dateTime, setDateTime] = useState(null);

  const onChangeDateTime = (val) => {
    setDateTime(val);
  };

  const onSubmit = () => {
    if (stocked) {
      const isCartType = true
      onProceed(selectedSearchItems, isCartType, dateTime);
      setDateTime(null);
    } else {
      onProceed();
    }
  };

  const onCancel = () => {
    setDateTime(null);
    setPopup(null);
  };

  const getItemMessages = () => {
    let msg = '';
    if (selectedTab === 'items') {
      msg = stocked ? FLABEL().OOS_ITEM_MESSAGE : FLABEL().OOS_IN_STOCK_ITEM_MESSAGE
    } else {
      msg = stocked ? FLABEL().OOS_MODIFIER_MESSAGE : FLABEL().OOS_IN_STOCK_MODIFIER_MESSAGE
    }
    return msg;
  }

  // popup
  return (
    <div className={cn(classes.popupContainer, 'd-flex align-items-center jutify-content-center')}>
      <span className={cn('fw-600')}>{FLABEL().OOS_UPDATE_STOCK_STATUS}</span>
      <div className={classes.contentWrapper}>
        <div>
          {getItemMessages()}
        </div>
        {stocked && (
          <div className={classes.inputWrapper}>
            <div className={classes.optionalMsg}>
              {selectedTab === 'items'? FLABEL().OOS_ITEM_DATE_MESSAGE : FLABEL().OOS_MODIFIER_DATE_MESSAGE}
            </div>
            <div className={cn(classes.inputs, 'col-12 px-0')}>
              <DateTimePicker
                value={dateTime}
                onChange={(e) => onChangeDateTime(e)}
                label={FLABEL().OOS_SELECT_DATE}
                minDate={new Date()}
                maxDate={new Date('2025-12-31')}
                withTime={true}
              />
            </div>
          </div>
        )}
      </div>
      <div className={cn('d-flex col-12 px-0 align-items-center jutify-content-center')}>
        <button className={cn(classes.Secondarybtn, classes.popupbtn, 'col mr-2')} onClick={onCancel}>{FLABEL().OOS_CANCEL}</button>
        <button className={cn(classes.primaryBtn, classes.popupbtn, 'col ml-2')} onClick={onSubmit}>{FLABEL().OOS_PROCEED}</button>
      </div>
    </div>
  );
};

export default StockStatusConfirmationPopup;
